import gql from 'graphql-tag'
export { SchoolTuitionBillingPolicyFields as ITuitionBillingPolicy } from './__generated__/SchoolTuitionBillingPolicyFields'

export const SchoolTuitionBillingPolicyFieldsFragment = gql`
  fragment SchoolTuitionBillingPolicyFields on SchoolTuitionBillingPolicy {
    id
    weeklyBillingAccepted
    weeklyBillingOffsetWeeks
    weeklyBillingDayOfWeek
    monthlyBillingOffsetMonths
    monthlyBillingOffsetDays
  }
`
